export const AUTH_SAVE = "SAVE"
export const AUTH_RESET = "RESET"